package fr.manyverse.app.presentation.auth

import androidx.compose.runtime.Composable

data class NativeAuthLaunchers(
    val signInWithGoogle: () -> Unit,
    val signInWithApple: () -> Unit
)

/**
 * Lance les connexions sociales.
 *
 * - **Google** : natif sur Android (Credential Manager via [rememberGoogleLauncher]) ; sur les autres
 *   plateformes (iOS, Desktop, Web) l'actual délègue à [onGoogleFallback] = flux OAuth navigateur.
 * - **Apple** : natif sur iOS (AuthenticationServices via [rememberAppleLauncher]) ; ailleurs, ou en
 *   cas d'échec du natif, flux OAuth navigateur ([onAppleFallback]).
 */
@Composable
fun rememberNativeAuthLaunchers(
    onGoogleFallback: () -> Unit,
    onAppleFallback: () -> Unit
): NativeAuthLaunchers {
    val googleLauncher = rememberGoogleLauncher(onFallback = onGoogleFallback)
    val appleLauncher = rememberAppleLauncher(onFallback = onAppleFallback)

    return NativeAuthLaunchers(
        signInWithGoogle = googleLauncher,
        signInWithApple = appleLauncher
    )
}
